import { Children, cloneElement, useEffect } from 'react';

import {
  useApplicationsGetQueryById,
  useApplicationsOfferGetQueryById,
} from '../../../Common/Queries/applicationsQueries';
import {
  useInterviewsDeleteQueryById,
  useInterviewsGetQueryById,
} from '../../../Common/Queries/interviewsQueries';
import { usePositionsGetQueryById } from '../../../Common/Queries/positionsQueries';
import { useTemplatesGetQueryByIds } from '../../../Common/Queries/templateQueries';

import { getInterviewByIdMap } from '../../../utils/responseMap.ts';

/**
 * this function is utility function for formate the data in required formate
 * @param {*} values remaining values
 * @param {*} editedValue edited values
 * @returns values in required formate
 */
export const formateData = (values, editedValue) => {
  const basicInfo = {
    round: values?.round ?? values?.basicInfo?.round,
    status: values?.status ?? values?.basicInfo?.status,
    text: editedValue?.reason,
  };
  const otherDetails = {
    versionKey: values?.versionKey ?? values?.otherDetails?.versionKey,
    message: values?.message ?? values?.otherDetails?.message ?? '',
    customLink: values?.customLink ?? values?.otherDetails?.customLink ?? '',
    timeZone: values?.timeZone ?? values?.otherDetails?.timeZone ?? 'Asia/Kolkata',
  };
  const interviewDetails = {
    startTime: values?.startTime ?? values?.interviewDetails?.startTime,
    duration: values?.duration ?? values?.interviewDetails?.duration,
    interviewer: values?.interviewer ?? values?.interviewDetails?.interviewer,
    location: values?.location ?? values?.interviewDetails?.location ?? 'ONLINE',
  };
  return {
    application: values?.application,
    basicInfo,
    otherDetails,
    interviewDetails,
  };
};

export function ExpandedEventContainer({
  children,
  setIsFieldLoading,
  setExpanded,
  event,
  ...props
}) {
  const interview = useInterviewsGetQueryById(event.interviewId, {
    select: (data) => getInterviewByIdMap(data),
  });
  const offer =
    event.type === 'LATEST OFFER' &&
    useApplicationsOfferGetQueryById(event.applicationId, event?.id, {});
  const deleteInterview = useInterviewsDeleteQueryById();

  const handleRefresh = () => {
    if (event.type === 'LATEST OFFER') {
      offer.refetch();
    } else {
      interview.refetch();
    }
  };

  const handleDelete = (finalValues) => {
    const reqBody = formateData(interview.data, finalValues);
    const reqParams = { reqBody, reqId: event.interviewId };
    deleteInterview.mutate(reqParams);
  };

  const applicationResponse = useApplicationsGetQueryById(event.applicationId);

  const positionResponse = usePositionsGetQueryById(
    {
      reqId: applicationResponse?.data?.position?.id,
    },
    {
      enabled: !!applicationResponse?.data?.position?.id,
    }
  );

  const olTemplateIDs = positionResponse?.data?.templateID || [];

  const olTemplates = useTemplatesGetQueryByIds(olTemplateIDs, {
    enabled: !!positionResponse?.data?.templateID,
  });

  useEffect(() => {
    setIsFieldLoading(deleteInterview.isLoading);
  }, [deleteInterview.isLoading]);

  useEffect(() => {
    if (deleteInterview.isSuccess) setExpanded(false);
  }, [deleteInterview.isSuccess]);

  return Children.only(
    cloneElement(children, {
      interview,
      offer,
      deleteInterview,
      event,
      handleRefresh,
      handleDeleteInterview: handleDelete,
      application: applicationResponse,
      olTemplates: olTemplates.map((res) => res.data),
      ...props,
    })
  );
}
